import { render, staticRenderFns } from "./expansion-panels.vue?vue&type=template&id=500301b0&scoped=true"
import script from "./expansion-panels.vue?vue&type=script&lang=js"
export * from "./expansion-panels.vue?vue&type=script&lang=js"
import style0 from "./expansion-panels.vue?vue&type=style&index=0&id=500301b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500301b0",
  null
  
)

export default component.exports